<template>
  <SummarySection title="Client" @edit="$emit('edit')">
    <dl class="mt-2 grid grid-cols-1 gap-x-3 gap-y-1.5 sm:grid-cols-2">
      <div v-if="customer.companyName">
        <dt class="text-xs font-medium text-gray-500">Raison sociale</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.companyName }}</dd>
      </div>
      <div v-if="customer.firstName">
        <dt class="text-xs font-medium text-gray-500">
          {{ isProfessional ? "Prénom du représentant" : "Prénom" }}
        </dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.firstName }}</dd>
      </div>
      <div v-if="customer.sirenNumber">
        <dt class="text-xs font-medium text-gray-500">SIREN</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.sirenNumber }}</dd>
      </div>
      <div v-if="customer.lastName">
        <dt class="text-xs font-medium text-gray-500">
          {{ isProfessional ? "Nom du représentant" : "Nom" }}
        </dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.lastName }}</dd>
      </div>
      <div v-if="customer.legalForm">
        <dt class="text-xs font-medium text-gray-500">Forme juridique</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ formatLegalForm(customer.legalForm) }}</dd>
      </div>
      <div v-if="customer.email">
        <dt class="text-xs font-medium text-gray-500">Email</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.email }}</dd>
      </div>
      <div v-if="customer.buyerRole">
        <dt class="text-xs font-medium text-gray-500">
          {{ isProfessional ? "Fonction du représentant" : "Profession" }}
        </dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.buyerRole }}</dd>
      </div>
      <div v-if="customer.phone">
        <dt class="text-xs font-medium text-gray-500">Téléphone</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.phone }}</dd>
      </div>

      <div v-if="customer.birthDate">
        <dt class="text-xs font-medium text-gray-500">Date de naissance</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ formatDate(customer.birthDate) }}</dd>
      </div>
      <div v-if="customer.birthCity">
        <dt class="text-xs font-medium text-gray-500">Ville de naissance</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ customer.birthCity }}</dd>
      </div>
      <div v-if="customer.birthCountry">
        <dt class="text-xs font-medium text-gray-500">Pays de naissance</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ getCountryName(customer.birthCountry) }}</dd>
      </div>
      <div v-if="customer.nationality">
        <dt class="text-xs font-medium text-gray-500">Nationalité</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ getCountryName(customer.nationality) }}</dd>
      </div>
      <!-- Adresse -->
      <div v-if="address.address1">
        <dt class="text-xs font-medium text-gray-500">Adresse</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.address1 }}</dd>
      </div>
      <div v-if="address.address2">
        <dt class="text-xs font-medium text-gray-500">Complément d'adresse</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.address2 }}</dd>
      </div>
      <div v-if="address.city">
        <dt class="text-xs font-medium text-gray-500">Ville</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.city }}</dd>
      </div>
      <div v-if="address.zipCode">
        <dt class="text-xs font-medium text-gray-500">Code postal</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.zipCode }}</dd>
      </div>
      <div v-if="address.province">
        <dt class="text-xs font-medium text-gray-500">Région / Province</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.province }}</dd>
      </div>
      <div v-if="address.country">
        <dt class="text-xs font-medium text-gray-500">Pays</dt>
        <dd class="mt-0.5 text-sm text-gray-900">{{ address.country }}</dd>
      </div>
    </dl>
  </SummarySection>
</template>

<script>
import { countries, isPresent } from "@estaly/ui";
import SummarySection from "./SummarySection.vue";

export default {
  components: { SummarySection },
  emits: ["edit"],
  props: {
    customer: {
      type: Object,
      required: true,
    },
    address: {
      type: Object,
      required: true,
    },
    isProfessional: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatDate(value) {
      if (!isPresent(value)) return "";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      return d.toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatLegalForm(value) {
      if (!isPresent(value)) return "";
      const legalForms = {
        sarl: "SARL",
        eurl: "EURL",
        sas: "SAS",
        sasu: "SASU",
        sa: "SA",
        ei: "EI",
        sca: "SCA",
        scs: "SCS",
        snc: "SNC",
      };
      return legalForms[value] || value.toUpperCase();
    },
    getCountryName(code) {
      if (!isPresent(code)) return "";
      const country = countries.find((c) => c.code === code);
      return country?.nameFr || code;
    },
  },
};
</script>
